import React, { useState } from 'react'
import { Modal } from 'components'
import styles from './index.module.less'
import WorkWechat from 'app/login/tabsPage/WorkWechat'
import Phone from 'app/login/tabsPage/Phone'

export default function Index({ goBack = () => {} }) {
  const [loginType, setLoginType] = useState(false)

  return (
    <Modal visible={true}>
      <div className={styles.box}>
        <div className={styles.header}>
          <p className={styles.back} onClick={goBack}>
            &lt; 返回登录
          </p>
          <div className={styles.title}>登录确认</div>
          <p className={styles.swtch} onClick={() => setLoginType(!loginType)}>
            {loginType ? '切换企业微信校验' : '切换手机验证码校验'} &ge;
          </p>
        </div>
        <div className={styles.tips}>
          <p>为了确认是本人登录</p>
          <p>
            {loginType
              ? '请使用手机验证码校验身份'
              : '请使用企业微信扫描二维码校验身份'}
          </p>
        </div>
        <div className={styles.centont}>
          {loginType ? (
            <div className={styles.phone}>
              <Phone />
            </div>
          ) : (
            <WorkWechat />
          )}
        </div>
        <div className={styles.foot}>
          <p>*仅限企业内部人员使用*</p>
        </div>
      </div>
    </Modal>
  )
}
